"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitButton = void 0;
var React = require("react");
var _Core_1 = require("../../_Core");
var browser = require("../../_Core/Browser");
var Animations_1 = require("../../Animations/");
var Icon_1 = require("../../Icons/Icon/Icon");
var Localization_1 = require("../../Localization");
var ButtonDropList_1 = require("../ButtonDropList");
var SplitButton_styles_1 = require("./SplitButton.styles");
var SplitButton = /** @class */ (function (_super) {
    __extends(SplitButton, _super);
    function SplitButton(props) {
        var _this = _super.call(this, props) || this;
        _this.buildClassName = function () {
            if (_this.state.Flow) {
                return _this.state.Flow.toString().toLowerCase();
            }
        };
        _this.handleLeftClick = function () {
            if (_this.props.OnClick) {
                _this.setState({ Flow: "Running" }, function () {
                    _this.props.OnClick(function () {
                        _this.setState({ Flow: "Complete" });
                    }, function () {
                        _this.setState({ Flow: "None" });
                    });
                });
            }
        };
        _this.state = {
            Flow: _this.props.Loading || "None",
        };
        return _this;
    }
    SplitButton.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        if (this.state.Flow !== props.Loading) {
            this.setState({ Flow: props.Loading });
        }
    };
    SplitButton.prototype.render = function () {
        return (React.createElement(SplitButton_styles_1.Wrapper, null,
            React.createElement(SplitButton_styles_1.LeftButton, { type: "button", className: this.buildClassName(), onClick: this.handleLeftClick, disabled: this.props.Disabled },
                this.props.Icon !== undefined ?
                    React.createElement(SplitButton_styles_1.IconContainer, { className: "icon" },
                        React.createElement(Icon_1.Icon, { Height: "24px", Width: "24px", Icon: this.props.Icon })) : undefined,
                React.createElement(SplitButton_styles_1.Caption, { className: "caption" }, this.props.Caption),
                this.state.Flow === "Running" ?
                    React.createElement(SplitButton_styles_1.Spinner, null) : null,
                this.state.Flow === "Complete" ?
                    // We are using the browser functions below to detect IE11 that does not support fully SVG Animations.
                    // This is the last resort to detect IE11 as we are not aware at this stage how to detect the missing functionality.
                    browser.HasDocumentMode() && browser.HasMSInputMethodContext() ?
                        React.createElement(SplitButton_styles_1.CompleteLegacy, null,
                            React.createElement(Animations_1.AnimatedTick, { Size: "32px" })) :
                        React.createElement(SplitButton_styles_1.Complete, null,
                            React.createElement(Animations_1.AnimatedTick, { Size: "32px" }))
                    : null),
            React.createElement(ButtonDropList_1.ButtonDropList, { Direction: this.props.Direction, AriaLabel: Localization_1.strings.Label_FurtherOptions, Disabled: this.props.Disabled, ShowIcon: true, ShowArrow: false, Icon: _Core_1.Icons.CaretDown, EndButton: true }, this.props.children)));
    };
    return SplitButton;
}(React.PureComponent));
exports.SplitButton = SplitButton;
